// extracted by mini-css-extract-plugin
export default {"introMessageAlt":"IntroMessageAlt_introMessageAlt__V1JvM","texts":"IntroMessageAlt_texts__cx-pr"};